import { Game } from '@/core/Game';
import { BootScene } from '@/scenes/BootScene';
import { initTelegram } from '@/platform/telegram';
import { loadArt } from '@/platform/art';

async function main(): Promise<void> {
  // Claim the full screen and the touch surface before anything renders.
  initTelegram();

  const mount = document.getElementById('game');
  if (!mount) throw new Error('#game mount not found');

  // Wait for the web fonts + generated art so the first frame is fully dressed.
  try {
    await Promise.race([
      Promise.all([(document as Document & { fonts: FontFaceSet }).fonts.ready, loadArt()]),
      new Promise((r) => setTimeout(r, 2200)),
    ]);
  } catch {
    /* fonts/art unavailable — proceed anyway */
  }

  const game = await Game.create(mount);
  game.startWith((g) => new BootScene(g));
  (window as unknown as { __game: Game }).__game = game;

  document.getElementById('boot')?.classList.add('hidden');
}

main().catch((err) => {
  console.error(err);
  const boot = document.getElementById('boot');
  if (boot) boot.textContent = 'Ошибка запуска: ' + (err as Error).message;
});
